import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class LoadPanelService {

  private visibilityNotifier$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  getLoadPanelVisibility(): Observable<boolean> {
    return this.visibilityNotifier$.asObservable();
  }

  setLoadPanelVisibility(isVisible: boolean): void {
    this.visibilityNotifier$.next(isVisible);
  }
}
